import {
  CarouselInterface,
  CarouselItemInterface,
} from 'src/shared/entities/carousel/carousel.schema'
import EntityTypeEnum from '../../../../common/enums/entityTypeEnum'

export function migrateCarousel(entity: CarouselInterface) {
  return {
    ...entity,
    type: EntityTypeEnum.Carousel,
  }
}

export function migrateCarouselItem(entity: CarouselItemInterface) {
  return {
    ...entity,
    type: EntityTypeEnum.CarouselItem,
  }
}
